import React from "react";
import styled from "styled-components";

//images
import HawkesSkullWhite from "../assets/images/all-hawkes-logos-new-hawkes-logo-eddie-white-copy-2@3x.png";

const FooterContainer = styled.footer`
  position: absolute;
  left: 0;
  right: 0;
  background-color: black;
  padding: 30px;
  > img {
    width: 52px;
    height: 70px;
    object-fit: contain;
  }
  > a {
    padding: 20px 0 0 0;
    display: block;
    font-family: GearedSlab;
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
`;

const Footer = () => (
  <FooterContainer>
    <img src={HawkesSkullWhite} alt="Hawkes Skull White Logo" />
    <a href="https://www.wearehawkes.com">WEAREHAWKES.COM</a>
  </FooterContainer>
);

export default Footer;
